import React, { SVGProps } from 'react';

const ProfileIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="100%"
			height="100%"
			viewBox="0 0 15 15"
			fill="none"
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.50044 2.18553C6.57092 2.18536 5.65761 2.42899 4.85168 2.8921C4.04575 3.35521 3.37537 4.02161 2.90747 4.82477C2.43957 5.62793 2.19051 6.53977 2.18514 7.46927C2.17978 8.39877 2.4183 9.31342 2.8769 10.1219C3.18687 9.71909 3.58533 9.39292 4.04148 9.16865C4.49762 8.94438 4.99924 8.82801 5.50753 8.82854H9.49334C10.0016 8.82801 10.5032 8.94438 10.9594 9.16865C11.4155 9.39292 11.814 9.71909 12.124 10.1219C12.5826 9.31342 12.8211 8.39877 12.8157 7.46927C12.8104 6.53977 12.5613 5.62793 12.0934 4.82477C11.6255 4.02161 10.9551 3.35521 10.1492 2.8921C9.34326 2.42899 8.42995 2.18536 7.50044 2.18553ZM12.777 11.5362C12.8602 11.4277 12.9399 11.3166 13.0161 11.2027C13.7526 10.1084 14.1452 8.81899 14.1434 7.49994C14.1434 3.83101 11.1694 0.856934 7.50044 0.856934C3.8315 0.856934 0.857429 3.83101 0.857429 7.49994C0.855335 8.95925 1.33575 10.3783 2.2239 11.5362L2.22057 11.5482L2.4564 11.8225C3.07944 12.551 3.85302 13.1356 4.72381 13.5362C5.59461 13.9368 6.54192 14.1438 7.50044 14.1429C7.64392 14.1429 7.78653 14.1385 7.92825 14.1297C9.12691 14.0541 10.2823 13.6533 11.2703 12.9705C11.7429 12.6445 12.1711 12.2586 12.5445 11.8225L12.7803 11.5482L12.777 11.5362ZM7.50044 3.51414C6.97189 3.51414 6.46498 3.7241 6.09124 4.09784C5.7175 4.47158 5.50753 4.97849 5.50753 5.50704C5.50753 6.03559 5.7175 6.54249 6.09124 6.91623C6.46498 7.28997 6.97189 7.49994 7.50044 7.49994C8.02899 7.49994 8.53589 7.28997 8.90963 6.91623C9.28337 6.54249 9.49334 6.03559 9.49334 5.50704C9.49334 4.97849 9.28337 4.47158 8.90963 4.09784C8.53589 3.7241 8.02899 3.51414 7.50044 3.51414Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default ProfileIcon;
